import { render, staticRenderFns } from "./EmployeeSalary.vue?vue&type=template&id=3166a68b&scoped=true&"
import script from "./EmployeeSalary.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalary.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSalary.vue?vue&type=style&index=0&id=3166a68b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3166a68b",
  null
  
)

export default component.exports